module.exports = __webpack_public_path__ + "img/orange-rectangle-table-10.fc012c4d.png";